import axios from "axios";

export const API = axios.create({
	baseURL: process.env.VUE_APP_BASE_URL,
});

export const apiConfig = (multipart = false) => {
	return { headers: getHeaders(multipart) };
};

function getHeaders(type) {
	const header = {};
	const token = localStorage.getItem("token");
	if (token) header.Authorization = `Bearer ${token}`;
	header.accept = `application/json`;
	if (type) header["Content-Type"] = "multipart/form-data";
	return header;
}

export const ROUTES = function (param = null) {
	return {
		register: "/register",
		verifyemail: "/email/verify",
		resendemaillink: "/email/resend-link",
		passwordresetlink: "/password/reset/send-link",
		resetpassword: "/password/reset",
		login: "/login",
		authuser: "/user",
		updatepassword: "/password/change",
		updateprofile: "/profile/update",
		payment: "/payment-keys",
		plans: "/plans",
		subscriptions: "/subscriptions",
		subscriptionpayment: `/subscriptions/get-link`,
		report: "/report",
		customers: "/customers",
		transactions: "/transactions",
		wallet: "/wallet",
		expenses: "/expenses",
		estimates: "/estimates",
		invoices: "/invoices",
		invoicepayment: "/payments",
		recordedPayments: `/payments`,
		invoicegeneralsettings: "/settings/invoice/general",
		invoicesummary: "/invoices/summary",
		preference: "/settings/preferences",
		taxsettings: "/settings/invoice/tax",
		notificationsettings: "/settings/notifications",
		settings: "/settings",
		bankaccount: "/bank-accounts",
		resolvebankaccount: "/bank-account",
		banklist: "/bank-list",
		analytics: "/analytics",
		customerinvoice: `/view/invoice/${param}`,
		customerestimate: `/view/estimate/${param}`,
		notifications: "/notifications",
		referrals: "/referred",
		customerinvoicepayment: "/payments/get-payment-link",
	};
};
